// @flow

export default {
  path: '/exportar-bases',
  component: () => import('modules/exportBases/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          }
        ]
      },
      name: 'exportBases',
      component: () => import('modules/exportBases/IconList.vue')
    },
    {
      path: 'recarga',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Recargas',
            name: 'exportRecharge'
          }
        ]
      },
      name: 'exportRecharge',
      component: () => import('modules/exportBases/exportRecharge.vue')
    },
    {
      path: 'chip',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Chip',
            name: 'exportChip'
          }
        ]
      },
      name: 'exportChip',
      component: () => import('modules/exportBases/exportChip.vue')
    },
    {
      path: 'capilaridade',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Capilaridade',
            name: 'exportCapillarity'
          }
        ]
      },
      name: 'exportCapillarity',
      component: () => import('modules/exportBases/exportCapillarity.vue')
    },
    {
      path: 'bipagem',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Bipagem',
            name: 'exportBeep'
          }
        ]
      },
      name: 'exportBeep',
      component: () => import('modules/exportBases/exportBeep.vue')
    },
    {
      path: 'ativacoes-duplicadas',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Ativações Duplicadas',
            name: 'exportDuplicateActivation'
          }
        ]
      },
      name: 'exportDuplicateActivation',
      component: () => import('modules/exportBases/exportDuplicateActivation.vue')
    },
    {
      path: 'import-history',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Histórico de Importação',
            name: 'exportImportHistory'
          }
        ]
      },
      name: 'exportImportHistory',
      component: () => import('modules/exportBases/exportImportHistory.vue')
    },
    {
      path: 'chip-movimentation',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Exportar Bases',
            name: 'exportBases'
          },
          {
            text: 'Movimentação de Chip',
            name: 'exportChipMovimentation'
          }
        ]
      },
      name: 'exportChipMovimentation',
      component: () => import('modules/exportBases/exportChipMovimentation.vue')
    }

  ]
};
